module.exports = __webpack_public_path__ + "img/dummyPoint.fed070c5.png";